
import { RsTransferModule } from 'rs-transfer';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { ProcessingImportFileComponent } from './processing-import-file';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
export const ROUTES/*: Routes*/ = [
    { path: 'processing-importer', component: ProcessingImportFileComponent },
];


@NgModule({
    imports: [
        RouterModule.forChild(ROUTES),
        FormsModule,
        BrowserModule,
        RsTransferModule
    ],
    declarations: [
        ProcessingImportFileComponent,
    ],
    exports: [
        ProcessingImportFileComponent,
    ],
})
export class ProcessingImportFileModule {}
